"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var vue_property_decorator_1 = require("vue-property-decorator");
var ExternalLink_1 = require("../../components/globals/ExternalLink");
var AppHeader_1 = require("../../components/globals/AppHeader");
var Policy_1 = require("../../components/globals/Policy");
var AuthSignUp = /** @class */ (function (_super) {
    __extends(AuthSignUp, _super);
    function AuthSignUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showPassword = false;
        _this.showPasswordConfirm = false;
        _this.form = {
            username: '',
            password: '',
            passwordConfirm: '',
            officeId: '',
            rehaplanUserId: ''
        };
        return _this;
    }
    AuthSignUp.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$cognito.adminAuthFlow()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthSignUp.prototype.onSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var params, authToken, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        if (this.form.password !== this.form.passwordConfirm) {
                            return [2 /*return*/];
                        }
                        params = JSON.stringify(this.form);
                        return [4 /*yield*/, this.$cognito.authTokenForAdmin()];
                    case 1:
                        authToken = _a.sent();
                        if (!!authToken) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.$cognito.adminAuthFlow()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        url = this.$invokeUrlMaker.create("user/create");
                        return [4 /*yield*/, axios_1.default.post(url, params, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function (err) {
                                console.log(err);
                                alert('エラー発生！！');
                                return;
                            })];
                    case 4:
                        res = _a.sent();
                        if (res) {
                            alert('アカウントを追加しました！');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthSignUp = __decorate([
        vue_property_decorator_1.Component({
            components: {
                Policy: Policy_1.default,
                AppHeader: AppHeader_1.default,
                ExternalLink: ExternalLink_1.default
            }
        })
    ], AuthSignUp);
    return AuthSignUp;
}(vue_property_decorator_1.Vue));
exports.default = AuthSignUp;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/auth/SignUp.vue
// module id = ozNo
// module chunks = 1